import { validations } from "./Validations";
import { Forms } from "../../../types/Forms";
import { __ } from "@wordpress/i18n";
import {
    QUOTE_PAYMENT_LABELS as LABELS,
    QUOTE_PAYMENT_OPTIONS as OPTIONS,
} from "./FormConfig";

// Constants for API configuration
const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/quote-payment`;
const PROCESS_TYPE = 4;
const OPERATION_TYPE = 2;


/**
 * Simulator custom URL - Check if exists some custom URL for this block
 * [==START==]
 */
let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector('[data-block="tool-block"]') as HTMLElement | null;
if ( rootElement !== null ) {
  const NEW_URL = rootElement.getAttribute('data-tool-managment');
  if ( NEW_URL !== null && NEW_URL !== '' ) {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}
/* [==END==] */


/**
 * Form configuration for the Quote Payment (Spanish mortgage payment) simulator.
 *
 * Numeric coercion (propertyValue/downPaymentAmount/loanTermInYears arrive
 * from the form as strings) happens on the PHP side, in QuotePaymentService —
 * the frontend submit path (ToolFormWithContext::onSubmit) JSON.stringifies
 * the raw Formik values as-is and does not apply any `api.transformData` hook.
 */
export const forms: Forms = {
    quote_payment: {
        validation: validations.quote_payment,
        api: {
            url: MIDDLEWARE_API_URL,
            headers: {
                "Content-Type": "application/json",
            },
            processType: PROCESS_TYPE,
            operationType: OPERATION_TYPE,
        },
        fields: [
            {
                type: "title",
                label: LABELS.title,
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.propertyValue,
                    },
                    {
                        type: "number",
                        label: "",
                        name: "propertyValue",
                        icon: "currency",
                        placeholder: "320.000,00",
                    },
                ],
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.downPaymentAmount,
                    },
                    {
                        type: "number",
                        label: "",
                        name: "downPaymentAmount",
                        icon: "currency",
                        placeholder: "115.000,00",
                    },
                ],
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.loanTermInYears,
                    },
                    {
                        // Plazo is the only field that keeps its own label in
                        // addition to the heading above it (shows on the
                        // select's border, unlike every other field here).
                        type: "select",
                        label: __("Anos", "df-simulators"),
                        name: "loanTermInYears",
                        options: OPTIONS.loanTermInYears,
                        defaultValue: "30",
                    },
                ],
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.rateType,
                    },
                    {
                        type: "select",
                        label: "",
                        name: "rateType",
                        options: OPTIONS.rateType,
                        defaultValue: "FIXED",
                    },
                ],
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.region,
                    },
                    {
                        type: "select",
                        label: "",
                        name: "region",
                        options: OPTIONS.region,
                        defaultValue: "MADRID",
                    },
                ],
            },
            {
                type: "group",
                label: "",
                group_fields: [
                    {
                        type: "heading",
                        label: LABELS.condition,
                    },
                    {
                        // Side-by-side only on tablet (md, 1024-1365px) —
                        // see the `.condition-radio` media query override in
                        // style.scss. Stays stacked (the default) on mobile
                        // and desktop.
                        type: "radio",
                        label: "",
                        className: "condition-radio",
                        name: "condition",
                        options: OPTIONS.condition,
                        defaultValue: "USADA",
                    },
                ],
            },
            // Fixed to Spain: the external API rejects any other value with a 422.
            {
                type: "hidden",
                label: "",
                name: "country",
                defaultValue: "ES",
            },
        ],
    },
};

export default forms;
